module.exports = __webpack_public_path__ + "img/brandDefault.0b541789.png";